module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-left-bottom-stone-path-background.1d8b94b0.png";